module.exports = __webpack_public_path__ + "media/images/game_icon/th/VG0003-7b82a58e9042d4d38935e8b2618c2db6.png";